import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IApiDependencySegment, catchApiError } from '@cbridge-packages/api-admin';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { UserListAction } from '../userList.action';

type IDependencies = IApiDependencySegment;

export const removeUser: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(UserListAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deleteUser(params).pipe(
      mergeMap(() => {
        return [
          UserListAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          UserListAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
